import React from 'react';
import Section from '../components/ui/Section';
import { Mail, Calendar, ArrowRight } from 'lucide-react';
import Button from '../components/ui/Button';

const ContactPage: React.FC = () => {
  return (
    <Section className="pt-32 md:pt-40">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">
          Get in <span className="text-primary">Touch</span>
        </h1>
        <p className="text-xl md:text-2xl text-neutral-300 mb-16">
          Let's discuss how we can help transform your AI initiatives
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          <div className="card p-8 md:p-10 flex flex-col items-center hover:border-primary/50 transition-colors">
            <div className="h-16 w-16 bg-primary/10 rounded-full flex items-center justify-center mb-6 transform transition-transform group-hover:scale-110">
              <Mail size={32} className="text-primary" />
            </div>
            <h2 className="text-2xl font-semibold mb-4">Email Us</h2>
            <p className="text-lg text-neutral-300 mb-8">
              Have a question or want to discuss your AI product challenges? Drop us a line.
            </p>
            <a 
              href="mailto:hello@productleapai.com"
              className="text-primary text-xl font-medium hover:underline mt-auto"
            >
              hello@productleapai.com
            </a>
          </div>

          <div className="card p-8 md:p-10 flex flex-col items-center hover:border-primary/50 transition-colors">
            <div className="h-16 w-16 bg-primary/10 rounded-full flex items-center justify-center mb-6 transform transition-transform group-hover:scale-110">
              <Calendar size={32} className="text-primary" />
            </div>
            <h2 className="text-2xl font-semibold mb-4">Book a Call</h2>
            <p className="text-lg text-neutral-300 mb-8">
              Schedule a free 30-minute consultation to discuss your AI product challenges.
            </p>
            <a 
              href="https://calendly.com/prodaiconsulting/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-auto w-full"
            >
              <Button className="w-full group">
                Book a 30-min Call
                <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default ContactPage;